export enum CameraType {
    ANAGLYPH,
    ARC_ROTATE,
    FOLLOW,
    FREE,
    UNIVERSAL,
    WEB_VR
}
